import { useAppDispatch } from "../../../../store/hooks";
import { setLayerModalLayers } from "../../../../store/interaction";
import RowForEdit from "./RowForEdit";
import RowForAdding from "./RowForAdding";


const LayerList = ({ temporaryLayerList, setTemporaryLayerList }: { temporaryLayerList: Layer[], setTemporaryLayerList: (l: Layer[]) => void }) => {

    const dispatch = useAppDispatch();

    function updateLayer(layer: Layer) {
        console.log(layer);
        
        setTemporaryLayerList(temporaryLayerList.map((i) => {
            if (i.id === layer.id) {
                return layer;
            } else {
                return i
            }
        }))
        console.log(temporaryLayerList);
    }

    function deleteLayerFromInnerState(layer: Layer) {
        const listAfterDelete = (temporaryLayerList.filter((i) => i.name !== layer.name))
        dispatch(setLayerModalLayers(listAfterDelete))
    }

    function listItemCreation(layers: Layer[]) {
        return layers.map((layer) => {
            return (
                <RowForEdit
                    key={layer.id}
                    item={layer}
                    setLayer={updateLayer}
                    removeLayer={deleteLayerFromInnerState}
                    deletable={temporaryLayerList.length > 1} />
            )
        })
    }

    return (
        <ul>
            {listItemCreation(temporaryLayerList)}
            <RowForAdding />
        </ul>
    )
}



export default LayerList